function createElementWithClass(parent, elementType, className, textContent = null) {
    const element = document.createElement(elementType);
    element.className = className;
    if (textContent) {
        element.innerText = textContent;
    }
    if (parent) {
        parent.appendChild(element);
    }
    return element;
}


function getOrCreateInnerParent(parent, className) {
    let innerParent = document.querySelector(`.${className}`);
    if (!innerParent) {
        innerParent = createElementWithClass(parent, 'div', className);
    }
    return innerParent;
}


function createTextElem(parentId, asset) {

    const elemParent = document.getElementById(parentId);
    if (!elemParent || !asset?.entryType) return;

    const child = createElementWithClass(null, 'div', asset.entryType);

    if (asset.includeAssetTitleAsAHeader) {
        createElementWithClass(child, 'div', 'kitTextHeader', asset.assetTitle);
    }

    child.innerHTML += richText(asset.text.content);

    const isHalfWidth = asset.entryType.toLowerCase().includes("halfwidth");
    const innerParentClass = `kitInnerParent${asset.entryType}`;
    const innerParent = getOrCreateInnerParent(elemParent, innerParentClass);

    innerParent.appendChild(child);
    if (!isHalfWidth) {
        elemParent.appendChild(innerParent);
    }
}


function processContentfulKitAsset(parent, asset) {
    const entryType = asset?.fields?.entryType;
    if (entryType && entryType.includes("Text") && !entryType.includes("specialText")) {
        createTextElem(parent, asset.fields);
    }
}


async function processContentfulLazily(contentfulFields) {
    for (let [key, value] of Object.entries(contentfulFields)) {
        try {
            if (typeof value === 'string') {
                fillTitleText(value, `#${key}`);
            } else if (value?.nodeType === 'document') {
                fillDescriptionText(richText(value.content), `#${key}`);
            } else if (isAssetLink(value)) {
                const img = await fetchImage(value);
                updateImage(key, img);
            } else if (key === "applicationIcons" && Array.isArray(value)) {
                const images = await fetchEntriesInBatch("assets", value.map(item => item.sys.id));
                images.forEach(img => createImage("hmgsBreak", img, key));
            } else if (key === "keyIngredients" && Array.isArray(value)) {
                setupKeyIngredientsContainers();
                const ingredients = await fetchEntriesInBatch("entries", value.map(item => item.sys.id));
                ingredients.forEach((ingredientData, i) => renderKeyIngredient(i, ingredientData));
            } else if (key === "body1" && Array.isArray(value)) {
                const entries = await fetchEntriesInBatch("entries", value.map(item => item.sys.id));
                entries.forEach(entry => processContentfulKitAsset(key, entry));
            }

            pageSpecificKitMods();

        } catch (error) {
            console.warn(error);
        }
    }
}



async function fetchEntriesInBatch(entryType, ids) {
    return await Promise.all(ids.map(id => fetchEntry(entryType, id)));
}

function isAssetLink(value) {
    return value && value.sys && value.sys.linkType === 'Asset';
}

async function fetchImage(assetLink) {
    return await fetchEntry("assets", assetLink.sys.id);
}




const getContentfulCore = (type, id=null) => {
    if (!id){
        id=collectionHandle;
    }
    const spaceId = 'r8ntwc7p992u';
    const accessToken = 'C_-9V7wqzxMRbmSgfL-8CKh5-MUboq-YQ2UOmB3WHnU';

    const contentful = `https://cdn.contentful.com/spaces/${spaceId}/entries?content_type=${type}&fields.collectionSlug[in]=${id}`;
    const headers = {
    Authorization: `Bearer ${accessToken}`
    };

    fetch(contentful, { headers })
    .then(response => response.json())
    .then(data => {

        const contentfulFields = data.items[0].fields;
        processContentfulLazily(contentfulFields);



    });
}


